import { Box, createStyles, Divider, Group } from '@mantine/core';

const useStyles = createStyles(() => ({
	leftColumn: {
		height: '100%',
		overflow: 'auto',
		width: '50%',
	},
	rightColumn: {
		width: '50%',
		height: '100%',
		overflow: 'auto',
	},
	group: {
		display: 'flex',
		flexFlow: 'row nowrap',
		overflow: 'auto',
	},
}));

export interface SnapshotModalBodyProps {
	leftColumn: React.ReactNode;
	rightColumn: React.ReactNode;
}

export function AiSettingModalContent({
	leftColumn,
	rightColumn,
}: SnapshotModalBodyProps) {
	const { classes } = useStyles();

	return (
		<Group spacing={0} align="flex-start" h="100%" className={classes.group}>
			<Box className={classes.leftColumn}>{leftColumn}</Box>
			<Divider orientation="vertical" />
			<Box className={classes.rightColumn}>{rightColumn}</Box>
		</Group>
	);
}
